<template>
  <div class="rs-thumbnail">
    <div class="thumb">
      <img :src="src">
      <span
        v-show="showDeleteBtn"
        class="thumb-delete"
        @click="$emit('on-delete')"
      >
        <i class="fa fa-times-circle" />
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsThumbnail',

  props: {
    src: {
      type: String,
      default: '',
    },

    showDeleteBtn: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss">
@import "@/styles/_variables.scss";

.rs-thumbnail {
  .thumb {
    position: relative;
    width: 8rem;
    img {
      object-fit: cover;
      height: 8rem;
      width: 8rem;
      border-radius: 5px;
    }
  }

  .thumb-delete {
    font-size: 1.2rem;
    position: absolute;
    right: -0.3rem;
    top: -0.3rem;
    cursor: pointer;
    i {
      background: #fff;
      padding: 4px;
      border-radius: 12px;
      color: $error;
      transition: color .2s ease;
      &:hover{
        color: darken($error, 10%);
      }
    }
  }
}
</style>
